var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 flip-cards-container"},_vm._l((_vm.selectedMenuItem),function(option,index){return _c('square-option',{key:index,attrs:{"option":option}})}),1),_c('div',{staticClass:"clearfix"})])
}
var staticRenderFns = []

export { render, staticRenderFns }